import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
//
import Layout from '../../components/Layout';
import ProductCard from '../../components/ProductCard';
import { getLinesheetProducts } from '../../api/services/productService';
import { isTokenExpired, navigateToLogin } from '../../utils';

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem 0 3rem;
  width: 100%;
`;

const Content = styled.div`
  width: 90%;
  max-width: 1300px;
`;

const SheetHeader = styled.section`
  position: relative;
  margin-bottom: 30px;
  padding: 18px 190px;
  background: #116546;
  color: #fff;
  text-align: center;

  @media (max-width: 768px) {
    padding: 18px 20px 16px;
  }
`;

const SheetMeta = styled.div`
  position: absolute;
  top: 18px;
  left: 20px;
  font-size: 14px;
  line-height: 1.35;
  text-align: left;

  @media (max-width: 768px) {
    position: static;
    margin-bottom: 8px;
  }
`;

const SheetTitle = styled.h1`
  margin: 0 0 2px;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const SheetDescription = styled.div`
  font-size: 16px;
  line-height: 1.25;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;

  > div {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  > div > div {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;

const StatusText = styled.div`
  text-align: center;
  padding: 3rem;
  color: #777;
`;

// Line Sheet 공유 링크 페이지 (로그인 필수)
export default function LinesheetPage() {
  const { idLinesheet } = useParams();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo);

  const [title, setTitle] = useState('');
  const [createdDt, setCreatedDt] = useState(null);
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    // 로그인 필수 - 미로그인 시 로그인 후 이 페이지로 복귀
    const token = localStorage.getItem('token');
    if (!token || isTokenExpired(token) || userInfo.userId == 0) {
      navigateToLogin(navigate, `/linesheet/${idLinesheet}`);
      return;
    }
    fetchLinesheet();
  }, [idLinesheet]);

  const fetchLinesheet = async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const result = await getLinesheetProducts(idLinesheet, userInfo.idStore);
      if (result.is_success) {
        setTitle(result.title || 'Line Sheet');
        setCreatedDt(result.createdDt || null);
        setProductList(result.productList || []);
      } else {
        setNotFound(true);
      }
    } catch (e) {
      setNotFound(true);
    }
    setLoading(false);
  };

  const formattedCreatedDate = createdDt
    ? new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
      }).format(new Date(createdDt))
    : '';

  return (
    <Layout>
      <Container>
        <Content>
          {loading ? (
            <StatusText>Loading...</StatusText>
          ) : notFound ? (
            <StatusText>Line sheet not found.</StatusText>
          ) : (
            <>
              <SheetHeader>
                <SheetMeta>
                  {formattedCreatedDate && (
                    <div>Created: {formattedCreatedDate}</div>
                  )}
                  <div>Simple Order # {idLinesheet}</div>
                </SheetMeta>
                <SheetTitle>e-SIMPLE ORDER</SheetTitle>
                <SheetDescription>
                  {userInfo.companyNm || title}, your customized product catalog
                  is ready.
                  <br />
                  Simply select order quantity and submit!
                </SheetDescription>
              </SheetHeader>
              {productList.length > 0 ? (
                <Grid>
                  {productList.map((item, index) => (
                    <div key={`linesheet_${item.idStyle}_${index}`}>
                      <ProductCard
                        data={item}
                        enableQuantity
                        accentColor='#116546'
                        accentHoverColor='#0c4a34'
                      />
                    </div>
                  ))}
                </Grid>
              ) : (
                <StatusText>No items in this line sheet.</StatusText>
              )}
            </>
          )}
        </Content>
      </Container>
    </Layout>
  );
}
